//ACCOUNTS SEARCH TIMEOUT
export const timeout = 500;

// TERMS AND CONDITIONS
export const TERMS_AND_CONDITIONS_KEY = "termsAcknowledged";
export const TERMS_AND_CONDITIONS_URL =
  "https://s3.us-east-1.amazonaws.com/assets-prod.ifinetwork.com/undefined/IFI+Network+Terms+and+Conditions.pdf";